import React from 'react'
import AirlineList from '../../components/airlines/AirlineList';

const Airlines = () => {
  return <AirlineList />
}

export default Airlines;
